import { render, staticRenderFns } from "./CardWithdrawalWinnings.vue?vue&type=template&id=57738ca3&"
import script from "./CardWithdrawalWinnings.vue?vue&type=script&lang=js&"
export * from "./CardWithdrawalWinnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports